// extracted by mini-css-extract-plugin
export default {"scoringForm":"ScoringRequestForm_scoringForm__YwopH"};